import { render } from "./EditableItemNumber.vue?vue&type=template&id=146838c8&scoped=true&ts=true"
import script from "./EditableItemNumber.vue?vue&type=script&lang=ts"
export * from "./EditableItemNumber.vue?vue&type=script&lang=ts"

import "./EditableItemNumber.vue?vue&type=style&index=0&id=146838c8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146838c8"]])

export default __exports__